<template>

    <section>
        <div>
            <table style="width: 100%;" class="mb-5">
                <thead>
                    <tr style="border-bottom: solid 2px #635bff; border-top: solid 2px #635bff; background-color: rgba(99, 91, 255, .1); color: rgb(99, 91, 255)!important;">
                        <th style="vertical-align: middle; width: 16.66%;" class="p-3">
                            Name
                            <button
                                style="text-align: center;"
                                type="button"
                                id="sort"
                                aria-label="Tri ascendant"
                                v-on:click="projectSortAsc">
                                <svg xmlns="http://www.w3.org/2000/svg" width="9" height="9" fill="rgb(107, 107, 107)" viewBox="0 0 16 16">
                                    <path d="m7.247 4.86-4.796 5.481c-.566.647-.106 1.659.753 1.659h9.592a1 1 0 0 0 .753-1.659l-4.796-5.48a1 1 0 0 0-1.506 0z"/>
                                </svg>
                            </button>
                            <button
                                style="text-align: center"
                                id="sort"
                                type="button"
                                aria-label="Tri descendant"
                                v-on:click="projectSortDsc">
                                <svg xmlns="http://www.w3.org/2000/svg" width="9" height="9" fill="rgb(107, 107, 107)" viewBox="0 0 16 16">
                                    <path d="M7.247 11.14 2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z"/>
                                </svg>
                            </button>
                        </th>
                        <th style="vertical-align: middle;width: 16.66%; text-align: center;" class="py-3">
                            Email
                        </th>
                        <th style="vertical-align: middle; width: 16.66%; text-align: center;">
                            Total assets
                        </th>
                        <th style="vertical-align: middle; width: 16.66%; text-align: center;">
                            Phone
                        </th>
                        <th style="vertical-align: middle; width: 16.66%; text-align: center;">
                            Account creation
                        </th>
                        <th style="vertical-align: middle; width: 16.66%; text-align: center;">
                        </th>
                    </tr>
                </thead>
                <tbody style="font-size: 14px; overflow: auto; max-height: 600px;">
                    <tr v-for="(customer, index) in customs" :key="index" style="border-bottom:solid 1px rgb(206,206,206);">
                        <td style="vertical-align: middle; width: 16.66%;" class="p-3 font-weight-bold">
                            {{ customer.firstname }} {{ customer.lastname }}
                        </td>
                        <td style="vertical-align: middle; width: 16.66%; text-align: center;">
                            {{ customer.email }}
                        </td>
                        <td style="vertical-align: middle; width: 16.66%; text-align: center;">
                            {{ customer.total_assets }}
                        </td>
                        <td style="vertical-align: middle; width: 16.66%; text-align: center;">
                            {{ customer.phone }}
                        </td>
                        <td style="vertical-align: middle; width: 16.66%; text-align: center;">
                            {{ customer.created_at }}
                        </td>
                        <td v-if="user.admin==1" style="vertical-align: middle; font-weight: bold; width: 16.66%; text-align: center;">
                            <a :href="'/delete_user/' + customer.id" onclick="return confirm('Are you sure? All data regarding this user will be deleted!')" class="btn-myfo-purple">
                                Delete
                            </a>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </section>

</template>

<script>
    export default {
        props: [
            'contacts',
            'user',
            'token',
            'route',
        ],

        data() {
            return {
                customs:[],
                filtername:"",
                filterproject:"",
                filterstatus:"",
            }
        },

        mounted() {
            this.contacts.forEach(customer =>
            {
                this.customs.push(customer)
            });
        },

        methods: {
            projectSortAsc(){

                this.customs = this.customs.sort(function(a, b){
                    if (a.firstname < b.firstname)
                    {
                        return -1;
                    }
                    else if (a.firstname > b.firstname)
                    {
                        return 1;
                    }
                    else
                    {
                        return 0;
                    }
                });
            },
            projectSortDsc(){
                this.customs = this.customs.sort(function(a, b){
                    if (a.firstname > b.firstname)
                    {
                        return -1;
                    }
                    else if (a.firstname < b.firstname)
                    {
                        return 1;
                    }
                    else
                    {
                        return 0;
                    }
                });
            },
    }
}

</script>